/**
 * @ais/dashboard-widgets — DashboardWidget contract + runtime loader +
 * built-in widget set for the supervision dashboard.
 *
 * Mirrors `@ais/plugin-host` for the dashboard's non-3D cell types. Consumers
 * construct a `DashboardWidgetHost`, call `registerBuiltins(host)` for the
 * stock set, then optionally `loadFromRegistry()` to pull marketplace widgets
 * with `kind === 'dashboard-widget'`.
 *
 * CSS for the built-in `viewer-snapshot` widget lives at
 *   ./src/builtin/viewer-snapshot/styles.css
 * and must be imported by the host app's stylesheet bundle (the package itself
 * has no build step, so consumers reference the CSS path directly via a Vite
 * `import '@ais/dashboard-widgets/src/builtin/viewer-snapshot/styles.css'`).
 */
import widgetsPkg from '../package.json';
export type {
  DashboardWidget,
  DashboardWidgetInstance,
  DashboardCtx,
  ResourceEntry,
  ResourceRef,
  ResourceType,
  // The cell bus — one cell reading another cell's plugin output.
  CellRun,
  CellPlugin,
  CellResult,
  CellFeed,
  CellFeedInput,
  CellSummary,
} from './Widget';
export { isResourceRef } from './Widget';
export {
  DashboardWidgetHost,
  type DashboardWidgetHostOptions,
  type DashboardWidgetLoadResult,
} from './Host';
export {
  registerBuiltins,
  viewerSnapshotWidget,
  cctvStreamWidget,
  chartWidget,
  recordListWidget,
  imageWidget,
} from './builtin/index';

// Lock-step with package.json — this constant is BOTH the engine version the
// widget host gates manifests against and the dashboard's build badge, so a
// drift silently rejects widgets that declare a newer range than it admits.
export const DASHBOARD_WIDGETS_VERSION: string = widgetsPkg.version;
